module.exports = "<main>\n  <record></record>\n  <td-issues></td-issues>\n</main>";


//////////////////
// WEBPACK FOOTER
// ./admin/src/app/components/main/main.component.html
// module id = 205
// module chunks = 1